<template>
    <div>
        <TitleAndExplanation v-if="title || explanation" :title="title" :explanation="explanation"/>
        <div class="select-container">
            <select 
                v-model="selectedOption"
                @change="emitSelectedOption" 
                class="select-input"
                :class="{ 'select-placeholder': isPlaceholderSelected }"
            >
                <option value="" disabled>{{ placeholder }}</option>
                <option 
                    v-for="option in options" 
                    :key="option.code" 
                    :value="option.code"
                >
                    {{ option.name }}
                </option>
            </select>
            <i class="fas fa-chevron-down select-icon"></i>
        </div>
    </div>
</template>

<script>
    import TitleAndExplanation from '../common/TitleAndExplanation.vue'

    export default {
        name:'InputSelect',
        components: {
            TitleAndExplanation
        },
        data() {
            return {
                selectedOption: this.selected || ''
            };
        },
        props: {
            options: {
                type: Array,
                required: true
            },
            placeholder: {
                type: String,
                default: ''
            },
            selected: {
                default: ''
            },
            title: {
                type: String,
                default: ''
            },
            explanation: {
                type: String,
                default: ''
            }
        },
        computed: {
            isPlaceholderSelected() {
                return this.selectedOption === '';
            }
        },    
        watch: {
            selected(newVal) {
                this.selectedOption = newVal;
            }
        },
        methods: {
            emitSelectedOption(event) {
                const value = event.target.value;
                this.$emit('valueChanged', value);
            }
        }
    }
</script>

<style scoped>
    .select-container {
        position: relative;
        width: 100%;  
    }
    .select-container select {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        padding-right: 2.5rem; 
        width: 100%;
    }
    .select-container .select-icon {
        pointer-events: none;
        position: absolute;
        right: 1rem;
        top: 50%;
        transform: translateY(-50%);
        color: var( --primary);
    }
    .select-input {
        border: 1px solid var(--gray-light);
        border-radius: var(--border-radius);
        padding: 12px 16px ;
        width: 100%;
        height: 56px;
        font-family: "Avenir Next", sans-serif;
        font-size: var(--font-size-inputs);
        font-weight: var(--font-weight-medium);
    }
    .select-input option{
        font-family: "Avenir Next", sans-serif;
    }
    .select-input:focus {
        border-color:var( --primary); 
    }
    .select-input.select-placeholder {
        font-size: var(--font-size-inputs);
        color: var(--gray);
        font-weight: var(--font-weight-medium);
    
    }
    /* MOVIL */
    @media (max-width: 768px) {
        .select-input {
            width: 100%;  
        }
    }

</style>
